import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Send, Mail, MapPin, Phone, Clock } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export default function Contatti() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Compila i campi obbligatori.");
      return;
    }
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/contacts`;
      await axios.post(url, form);
      toast.success("Messaggio inviato. Ti risponderemo a breve.");
      setForm({ name: "", email: "", company: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Invio non riuscito. Riprova fra poco.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="contatti"
      data-testid="contatti-section"
      className="relative section-pad section-gap"
    >
      <div className="grid md:grid-cols-12 gap-12">
        <Reveal className="md:col-span-5">
          <p className="text-[0.7rem] tracking-[0.3em] uppercase text-neutral-500 mb-3">
            04 / Contatti
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-neutral-50 leading-[0.95] mb-8">
            Parliamo
            <br />
            <span className="italic font-editorial font-normal text-[var(--accent)]">
              di pietra.
            </span>
          </h2>
          <p className="text-neutral-400 leading-relaxed max-w-sm mb-10">
            Per richieste di blocchi, lastre, lavorazioni speciali o per visite alla
            cava: lasciaci un messaggio, rispondiamo entro 48 ore.
          </p>

          <ul className="space-y-5 text-sm text-neutral-300">
            <li className="flex items-start gap-4">
              <MapPin size={16} className="mt-0.5 text-[var(--accent)] shrink-0" />
              <div>
                <p className="text-neutral-200">Via F. Rosazza 4 · Sagliano Micca (BI)</p>
                <p className="text-xs text-neutral-500 mt-1">13816 — Piemonte, Italia</p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <Mail size={16} className="mt-0.5 text-[var(--accent)] shrink-0" />
              <a href="mailto:gmbgranitisrl@gmail.com" className="hover:text-[var(--accent)] transition-colors">
                gmbgranitisrl@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-4">
              <Phone size={16} className="mt-0.5 text-[var(--accent)] shrink-0" />
              <a href="tel:+390152477195" className="hover:text-[var(--accent)] transition-colors">
                015 2477195
              </a>
            </li>
            <li className="flex items-start gap-4">
              <Clock size={16} className="mt-0.5 text-[var(--accent)] shrink-0" />
              <div>
                <p className="text-neutral-200">Lun — Ven</p>
                <p className="text-xs text-neutral-500 mt-1">08:00 — 12:00 · 14:00 — 16:00</p>
              </div>
            </li>
          </ul>
        </Reveal>

        <Reveal as="form" delay={0.15}
          data-testid="contact-form"
          onSubmit={onSubmit}
          className="md:col-span-7 grid grid-cols-2 gap-px bg-[var(--border-subtle)]"
        >
          <div className="bg-[var(--surface-1)] p-1">
            <input
              data-testid="contact-name"
              className="input-base"
              placeholder="Nome*"
              name="name"
              value={form.name}
              onChange={onChange}
              required
            />
          </div>
          <div className="bg-[var(--surface-1)] p-1">
            <input
              data-testid="contact-email"
              className="input-base"
              placeholder="Email*"
              name="email"
              type="email"
              value={form.email}
              onChange={onChange}
              required
            />
          </div>
          <div className="bg-[var(--surface-1)] p-1">
            <input
              data-testid="contact-company"
              className="input-base"
              placeholder="Azienda / Studio"
              name="company"
              value={form.company}
              onChange={onChange}
            />
          </div>
          <div className="bg-[var(--surface-1)] p-1">
            <input
              data-testid="contact-subject"
              className="input-base"
              placeholder="Oggetto"
              name="subject"
              value={form.subject}
              onChange={onChange}
            />
          </div>
          <div className="bg-[var(--surface-1)] p-1 col-span-2">
            <textarea
              data-testid="contact-message"
              className="input-base resize-none"
              placeholder="Messaggio*"
              name="message"
              rows={6}
              value={form.message}
              onChange={onChange}
              required
            />
          </div>
          <div className="bg-[var(--surface-1)] p-4 col-span-2 flex items-center justify-between flex-wrap gap-4">
            <p className="text-xs text-neutral-500 max-w-md">
              Inviando il modulo accetti che i tuoi dati siano utilizzati per
              ricontattarti. Nessuna comunicazione di marketing.
            </p>
            <button
              data-testid="contact-submit-btn"
              type="submit"
              disabled={loading}
              className="btn-primary disabled:opacity-60"
            >
              {loading ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
              {loading ? "Invio…" : "Invia messaggio"}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
